import { type IBaseModalProps } from '@gbs-monorepo-packages/common';

import {
  Arrow,
  ArrowDown,
  ArrowUp,
  ArrowsContainer,
  Container,
  Text,
} from './styles';

interface IButtonArrowsProps
  extends Partial<Omit<IBaseModalProps, 'children' | 'onOpenChange'>> {
  text: string;
  id: number;
  prop: string;
  type: string;
  pageId: number;
  onArrowClick: (
    direction: 'down' | 'up',
    index: number,
    prop: string,
    type: string,
    pageId: number
  ) => void;
}

export const ButtonArrows = ({
  text,
  id,
  prop,
  type,
  pageId,
  onArrowClick,
}: IButtonArrowsProps): JSX.Element => {
  const handleArrowClick = (direction: 'down' | 'up') => {
    onArrowClick(direction, id, prop, type, pageId);
  };

  return (
    <Container>
      <Text>{text}</Text>
      <ArrowsContainer>
        <Arrow
          onClick={() => {
            handleArrowClick('up');
          }}
        >
          <ArrowUp />
        </Arrow>
        <Arrow
          onClick={() => {
            handleArrowClick('down');
          }}
        >
          <ArrowDown />
        </Arrow>
      </ArrowsContainer>
    </Container>
  );
};
